import type { ReactNode } from 'react';
import type { WidgetProps } from './types';

/**
 * Interrupteur `toggle` d'un champ oui / non (ADR-146 §6.1) : rôle `switch`, Espace ou Entrée pour
 * basculer, l'état écrit à côté (« Oui » / « Non »). Une réponse jamais donnée reste vide (`null`)
 * jusqu'au premier appui : l'interrupteur ne répond pas « Non » à la place de l'opérateur.
 */
export function Toggle({ id, field, value, onChange, disabled, invalid, describedBy }: WidgetProps): ReactNode {
  if (field.type !== 'boolean') return null;
  const on = value === true;
  const state = value === true ? 'Oui' : value === false ? 'Non' : 'Non renseigné';
  return (
    <button
      id={id}
      type="button"
      role="switch"
      className={`ay-toggle${on ? ' ay-toggle--on' : ''}${value === null || value === undefined ? ' ay-toggle--unset' : ''}`}
      aria-checked={on}
      aria-labelledby={`${id}-label`}
      aria-invalid={invalid}
      aria-describedby={describedBy}
      disabled={disabled}
      onClick={() => onChange(!on)}
    >
      <span className="ay-toggle__track" aria-hidden="true">
        <span className="ay-toggle__knob" />
      </span>
      <span className="ay-toggle__state">{state}</span>
    </button>
  );
}
